import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

import { reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { GetStampUseReportApi, StampUseExportApi } from '../../../apis/reports/apis';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { formatTools } from '../../../utils/index';
import { saveAs } from 'file-saver';
import { ElMessage } from 'element-plus';
import { useCtCategory } from '@/store/category.store';
import { useDictionary } from '@/store/dictionary.store';
// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetStampUseReportApi,
	response: { data: 'data', total: 'total' },
});

const { push } = useRouter();
const { getName, getSelectList } = useDictionary();
const { setSearchParams } = methods;
const { fDateTime } = formatTools();

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'action_time', label: t('reports.stampsuse.table.stampDate', '盖章日期'), columnWidth: '120', align: 'center' },
	{ field: 'stamp_code', label: t('reports.stampsuse.table.stampNo', '印章编号'), columnWidth: '120', align: 'center' },
	{ field: 'stamp_name', label: t('reports.stampsuse.table.stampName', '印章名称'), columnWidth: '150', headerAlign: 'center' },
	{ field: 'stamp_type', label: t('reports.stampsuse.table.stampType', '印章分类'), columnWidth: '80', align: 'center' },
	{ field: 'contract_no', label: t('contract.no', '合同编号'), columnWidth: '150', headerAlign: 'left' },
	{ field: 'contract_name', label: t('contract.name', '合同名称'), headerAlign: 'center' },
	{ field: 'party_b_name', label: t('reports.stampsuse.table.counterpart', '相对方(乙方)'), headerAlign: 'center' },
	{ field: 'party_b_type', label: t('reports.stampsuse.table.counterpartType', '相对方类别'), align: 'center', columnWidth: '100' },
	{ field: 'file_total', label: t('reports.stampsuse.table.stampFileCount', '用印文件数'), width: '100', headerAlign: 'center', align: 'right' },
	{ field: 'dept_name', label: t('reports.stampsuse.table.applicantDept', '申请部门'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'user_name', label: t('reports.stampsuse.table.applicant', '申请人'), columnWidth: '120', fixed: 'right', align: 'center' },
	{ field: 'action', width: '100', label: t('contractList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const state = reactive({
	loading: false,
	dlLoading: false,
	queryParams: {} as any,
	categoryList: [] as any[],
	pagedParams: { page_size: 10, current: 1 } as any,
});

const actions = {
	onSearch: () => {
		const search = Object.assign(state.queryParams, state.pagedParams);
		setSearchParams(search);
	},

	reSet: () => {
		state.queryParams = { party_b_type: '' };
		actions.onSearch();
	},
	showDetail: (row: any) => {
		push({ path: `/contracts/previews`, query: { contractId: `${row.contract_id}` } });
	},
	/* 导出Excel */
	exports: async () => {
		state.dlLoading = true;

		const search = Object.assign(state.queryParams, state.pagedParams);
		await StampUseExportApi(search)
			.then((res: any) => {
				const { status, data } = res;
				if (status != 200) ElMessage.error(t('reports.stampsuse.message.exportFailed', '导出失败，请联系管理员'));
				else {
					const blob = new Blob([data]);
					const title = `${search.party_b_type ? getName('stamp_type', search.party_b_type) : ''}${t('reports.stampsuse.title.stampUsageReport', '印章使用登记表')}.xlsx`;
					saveAs(blob, title);
				}
			})
			.catch((err) => {
				ElMessage.error(err);
			})
			.finally(() => {
				state.dlLoading = false;
			});
	},
};

onMounted(() => {
	state.categoryList = useCtCategory().getTreeList();

	const search = Object.assign(state.queryParams, state.pagedParams);
	setSearchParams(search);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, {
      shadow: "never",
      "body-style": { paddingBottom: '0' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).queryParams,
          inline: true
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _unref(t)('contract.name', '合同名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).queryParams.contract_name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).queryParams.contract_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('reports.stampsuse.form.stampName', '印章名称')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: _unref(state).queryParams.stamp_name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).queryParams.stamp_name) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('reports.stampsuse.form.stampType', '印章类别')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(state).queryParams.stamp_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).queryParams.stamp_type) = $event)),
                  placeholder: _unref(t)('reports.stampsuse.form.stampTypePlaceholder', '印章类别'),
                  onChange: actions.onSearch
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('stamp_type', true), (dic) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: dic.label,
                        value: dic.value
                      }, null, 8, ["label", "value"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('reports.stampsuse.form.contractCategory', '合同分类')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tree_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(state).queryParams.category_id,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).queryParams.category_id) = $event)),
                  data: _unref(state).categoryList,
                  accordion: "",
                  filterable: "",
                  clearable: "",
                  placeholder: _unref(t)('reports.stampsuse.form.contractCategoryPlaceholder', '请选择合同分类')
                }, null, 8, ["modelValue", "data", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _unref(t)('reports.stampsuse.form.supplierType', '供应商类型')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  style: {"width":"100%"},
                  modelValue: _unref(state).queryParams.party_b_type,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(state).queryParams.party_b_type) = $event)),
                  placeholder: _unref(t)('reports.stampsuse.form.supplierTypePlaceholder', '供应商类型'),
                  onChange: actions.onSearch
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _unref(t)('reports.stampsuse.status.all', '全部'),
                      value: ""
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('reports.stampsuse.status.internalUnit', '内部单位'),
                      value: "1"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('reports.stampsuse.status.supplier', '供应商'),
                      value: "2"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('reports.stampsuse.status.customer', '客户'),
                      value: "3"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('reports.stampsuse.status.partner', '合作伙伴'),
                      value: "4"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _unref(t)('reports.stampsuse.status.other', '其他'),
                      value: "99"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: "Search",
                      type: "primary",
                      onClick: actions.onSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      icon: "RefreshRight",
                      onClick: actions.reSet
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.cancel', '重置')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      icon: "Download",
                      disabled: _unref(state).dlLoading,
                      onClick: actions.exports
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('buttons.export', '导出')), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_component_el_form, {
          size: "small",
          model: _unref(state).queryParams,
          inline: true
        }, null, 8, ["model"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      style: {"margin-top":"10px"},
      disabled: _unref(tableObject).loading
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(GbTables), {
          pageSize: _unref(tableObject).pageSize,
          "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
          currentPage: _unref(tableObject).currentPage,
          "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
          columns: _unref(tabColumns),
          data: _unref(tableObject).tableList,
          loading: _unref(tableObject).loading,
          pagination: { total: _unref(tableObject).total },
          onRegister: _unref(register)
        }, {
          stamp_type: _withCtx(({ row }) => [
            _createVNode(_component_el_tag, { size: "small" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getName)('stamp_type', row.stamp_type)), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          action_time: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(fDateTime)(row.action_time)), 1)
          ]),
          file_total: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.file_total), 1)
          ]),
          party_b_type: _withCtx(({ row }) => [
            (row.party_b_type == '1')
              ? (_openBlock(), _createBlock(_component_el_tag, { key: 0 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('reports.stampsuse.status.internalUnit', '内部单位')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (row.party_b_type == '2')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 1,
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('reports.stampsuse.status.supplier', '供应商')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (row.party_b_type == '3')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 2,
                  type: "warning"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('reports.stampsuse.status.customer', '客户')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (row.party_b_type == '4')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 3,
                  type: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('reports.stampsuse.status.partner', '合作伙伴')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (row.party_b_type == '99')
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 4,
                  type: "info"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('reports.stampsuse.status.other', '其他')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          action: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              icon: "Memo",
              type: "primary",
              size: "small",
              text: "",
              onClick: ($event: any) => (actions.showDetail(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('buttons.detail', '详 细')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}
}

})